import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { userInfoByNumberAtom } from '../../Services/_states';
import { LeadFormActions } from '../../Services/_actions';

const Header: React.FC = () => {
  const action = LeadFormActions();
  const [userDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const [leadCounts, setLeadCounts] = React.useState<any>(null);
    const leadWebFormData = JSON.parse(
    localStorage.getItem('leadWebFormData') || '{}'
  );

  const CampaignId = leadWebFormData?.campaign?.proposal_id || '';
  const LeadFormId = leadWebFormData?.webForm?.leads_form_id || '';
  const SupplierId = leadWebFormData?.phoneNumber;

  const stats = [
    { label: 'Total Leads', value: leadCounts?.total_leads ?? 0, bg: '#E3F2FD', color: '#1976D2' },
    { label: 'Recent Leads', value: leadCounts?.last_24h_leads ?? 0, bg: '#E8F5E9', color: '#2E7D32' },
    { label: 'Closed Leads', value: leadCounts?.closed_leads ?? 0, bg: '#FFF3E0', color: '#ED6C02' },
    { label: 'Open Leads', value: leadCounts?.open_leads ?? 0, bg: '#F3E5F5', color: '#9C27B0' },
  ];

  const getLeadCountDetails = async () => {
  try {
    const payload = {
      ...userDetailByNumber,
      supplier_id:SupplierId || '',
      campaign_id: CampaignId || '',
      leadform_Id: LeadFormId || '',
    };

    const res = await action.getLeadCounts(payload);

    if (res?.status === 200) {
      setLeadCounts(res.data);
    }
  } catch (error) {
    console.error('Lead count error', error);
  }
};

  React.useEffect(() => {
      getLeadCountDetails();
    
  }, [userDetailByNumber, CampaignId, LeadFormId,SupplierId]);

  return (
    <Grid container spacing={1}>
      {stats.map((item, index) => (
        <Grid
          key={index}
          item
          xs={6}     // ✅ Mobile → 2 cards per row
          sm={6}
          md={3}     // ✅ Desktop → 4 cards per row
        >
          <Box
            sx={{
              backgroundColor: item.bg,
              borderRadius: 1.5,
              px: 1.5,
              py: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: 48,
              mt:{ xs: 1, sm:0}
            }}
          >
            <Typography
              variant="caption"
              sx={{ color: item.color, fontWeight: 600 }}
            >
              {item.label}
            </Typography>

            <Typography
              variant="body1"
              sx={{ color: item.color, fontWeight: 700 }}
            >
              {item.value}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Header;
